var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFilterSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 2.33317C24.9198 2.33317 25.666 3.07936 25.666 3.99984V23.9998C25.666 24.9203 24.9198 25.6665 23.9993 25.6665H3.99935C3.07887 25.6665 2.33268 24.9203 2.33268 23.9998V3.99984C2.33268 3.07936 3.07887 2.33317 3.99935 2.33317H23.9993ZM3.99935 0.666504C2.1584 0.666504 0.666016 2.15889 0.666016 3.99984V23.9998C0.666016 25.8408 2.1584 27.3332 3.99935 27.3332H23.9993C25.8403 27.3332 27.3327 25.8408 27.3327 23.9998V3.99984C27.3327 2.15889 25.8403 0.666504 23.9993 0.666504H3.99935Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 19.8332C10.666 19.3729 11.0391 18.9998 11.4993 18.9998H16.4993C16.9596 18.9998 17.3327 19.3729 17.3327 19.8332C17.3327 20.2934 16.9596 20.6665 16.4993 20.6665H11.4993C11.0391 20.6665 10.666 20.2934 10.666 19.8332Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33268 14.8332C7.33268 14.3729 7.70578 13.9998 8.16602 13.9998H19.8327C20.2929 13.9998 20.666 14.3729 20.666 14.8332C20.666 15.2934 20.2929 15.6665 19.8327 15.6665H8.16602C7.70578 15.6665 7.33268 15.2934 7.33268 14.8332Z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99935 9.83317C3.99935 9.37293 4.37245 8.99984 4.83268 8.99984H23.166C23.6263 8.99984 23.9993 9.37293 23.9993 9.83317C23.9993 10.2934 23.6263 10.6665 23.166 10.6665H4.83268C4.37245 10.6665 3.99935 10.2934 3.99935 9.83317Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilterSquare);
export default __webpack_public_path__ + "static/media/ico-filter-square.8babb6c7c74c41d99283d7e9744f9863.svg";
export { ForwardRef as ReactComponent };